import { NonPerformanceCode as GqlNonPerformanceCode } from '@willow/graphql-iso/src/app';
import { NonPerformanceCode } from '@willow/types-iso';

export const GqlNonPerformanceCodeToNonPerformanceCode: Record<GqlNonPerformanceCode, NonPerformanceCode> = {
  AppealOfLoanModification: 'Appeal of Loan Modification',
  Assignment: 'Assignment',
  Assumption: 'Assumption',
  BPOAppraisalObtained: 'BPO/Appraisal Obtained',
  BPOOrdered: 'BPO Ordered',
  BankruptcyCourtClearanceObtainedStayLifted: 'Bankruptcy Court Clearance Obtained/Stay Lifted',
  BankruptcyCramdownScheduled: 'Bankruptcy Cramdown Scheduled',
  BankruptcyPlanConfirmed: 'Bankruptcy Plan Confirmed',
  BankruptcyPropertySurrendered: 'Bankruptcy–Property Surrendered',
  BreachLetterSent: 'Breach Letter Sent',
  Chapter7AssetCase: 'Chapter 7 Asset Case',
  Chapter7Bankruptcy: 'Chapter 7 Bankruptcy',
  Chapter11Bankruptcy: 'Chapter 11 Bankruptcy',
  Chapter12Bankruptcy: 'Chapter 12 Bankruptcy',
  Chapter13Bankruptcy: 'Chapter 13 Bankruptcy',
  ChargeOff: 'Charge‑off',
  CompleteBorrowerResponsePackage: 'Complete Borrower Response Package',
  ContestedLitigatedForeclosure: 'Contested/Litigated Foreclosure',
  DateAdvisedPropertyListedForSale: 'Date Advised Property Listed for Sale',
  DateOfFirstLegalAction: 'Date of First Legal Action',
  DateOfFirstQRPC: 'Date of First QRPC',
  DateOfLastQRPC: 'Date of Last QRPC',
  DelinquentNoAction: 'Delinquent—No Action',
  DrugSeizure: 'Drug Seizure',
  Forbearance: 'Forbearance',
  Foreclosure: 'Foreclosure',
  ForeclosureSaleScheduled: 'Foreclosure Sale Scheduled',
  GovernmentSeizure: 'Government Seizure',
  IneligibleCancelModification: 'Ineligible/Cancel Modification',
  IneligibleForShortSale: 'Ineligible for Short Sale',
  MilitaryIndulgence: 'Military Indulgence',
  Modification: 'Modification',
  ModificationInReview: 'Modification in Review',
  MortgageRelease: 'Mortgage Release',
  PaymentDeferralOffer: 'Payment Deferral Offer',
  Probate: 'Probate',
  QualityRightPartyContact: 'Quality Right Party Contact',
  Refinance: 'Refinance',
  Reinstatement: 'Reinstatement',
  RepaymentPlan: 'Repayment Plan',
  RepaymentPlanInReview: 'Repayment Plan in Review',
  SecondLienConsiderations: 'Second Lien Considerations',
  ShortSaleApprovedMarketingProperty: 'Short Sale Approved/Marketing Property',
  ShortSaleApprovedOfferReceived: 'Short Sale Approved/Offer Received',
  ShortSaleInReview: 'Short Sale in Review',
  SolicitationLetterSent: 'Solicitation Letter Sent',
  ThirdPartySale: 'Third‑Party Sale',
  TrialModification: 'Trial Modification',
  VABuydown: 'VA—Buydown',
  VANoBid: 'VA—No Bid',
  VARefund: 'VA—Refund',
  WorkoutInReview: 'Workout in Review',
} as const;
